var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,1c-0.31786,0.00044 -0.61658,0.15198 -0.80469,0.4082c-0.01008,0.01278 -0.01985,0.02581 -0.0293,0.03906c-2.36112,3.03831 -8.16602,12.5762 -8.16602,17.55273c0,4.971 4.029,9 9,9c4.971,0 9,-4.029 9,-9c0,-4.97094 -5.792,-14.48956 -8.1582,-17.53906c-0.00027,-0.00035 0.00027,-0.00161 0,-0.00195c-0.01183,-0.01731 -0.02421,-0.03425 -0.03711,-0.05078c-0.18811,-0.25622 -0.48683,-0.40776 -0.80469,-0.4082zM9,18c0.553,0 1,0.447 1,1c0,2.11 1.33998,4.00298 3.33398,4.70898c0.52,0.184 0.79242,0.75439 0.60742,1.27539c-0.145,0.41 -0.52941,0.66602 -0.94141,0.66602c-0.11,0 -0.22398,-0.01764 -0.33398,-0.05664c-2.791,-0.987 -4.66602,-3.63775 -4.66602,-6.59375c0,-0.553 0.447,-1 1,-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.bdb424123ac4a750a15f43c1e18e8733.svg";
export { ForwardRef as ReactComponent };